import React from 'react'
import { Card as AntCard } from 'antd'
import { CardProps } from './props'
import styles from './styles.scss'

export const Card: React.FC<CardProps> = (props) => <AntCard {...props} />
